import React from "react";
import { useRouter } from "next/router";
import CurriculumHeader from "components/header/CurriculumHeader";

const ConceptsId = () => {
  const router = useRouter();
  const id = router.query.id;
  return id === "geography" ? (
    <div className="flex flex-col justify-center gap-24 xl:gap-10 mx-24 mt-10">
      <CurriculumHeader
        title="ՀԱՅԵՑԱԿԱՐԳԵՐ"
        sectionTitle="ԱՇԽԱՐՀԱԳՐՈՒԹՅՈՒՆ"
        buttonTitle="Առարկայացանկ"
        buttonLink={"/subjects-list"}
      />
      <div class="xl:p-[48px_100px] justify-between items-center bg-white rounded-[24px]">
        <h3 class="text-[#493ED3] font-noto-sans-armenian text-[24px] font-semibold leading-normal mb-4">
          ԲԱԺԻՆ 1. ԸՆԴՀԱՆՈՒՐ ԴՐՈՒՅԹՆԵՐ
        </h3>
        <p className="text-black indent-8 font-noto-sans-armenian text-[18px] font-medium leading-normal">
          Ազգային կրթակարգով ձևավորվող ազգային դպրոցում Աշխարհագրության
          ուսուցումն ունի հստակ նպատակադրում՝ ապահովել ազգային և քաղաքակրթական
          դաստիարակություն, հայրենիքի՝ Հայաստանի և Աշխարհի մասին (լոկալ,
          ռեգիոնալ և գլոբալ մակարդակների) աշխարհագրական գիտելիքների,
          կարողությունների և հմտությունների միջոցով:
        </p>
        <p className="my-4 text-[#493ED3] font-noto-sans-armenian text-[18px] font-semibold leading-normal">
          Սահմանված գերնպատակն իր մեջ ամբողջացնում է դպրոցական դասական
          աշխարհագրության արդիականացված նպատակներ, որոնց իրացման արդյունքում
          ակնկալվում է․
        </p>
        <ul className="ml-4 list-disc pl-5 text-black font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <li>
            սովորողների մեջ ձևավորել աշխարհագրական տարածաժամանակային, խորքային
            համակարգված մտածողություն,
          </li>
          <li>
            ապահովել, որ սովորողներն ունենան ոլորտի համաշխարհային ձեռբերքումների
            ճանաչման և սեփական հայրենիքում դրանց կիրառման կարողություն,
          </li>
          <li>
            սովորողներ, ունենան համամշակութային արժեքների ճանաչման և սեփական
            քաղաքակրթական արժեքների հետ ներդաշնակման կարողություններ,
          </li>
          <li>
            ազգային կրթակարգի շրջանակներում ուսուցանվող առարկաների հետ համատեղ
            սովորողների մեջ ապահովել,
          </li>
          <li>
            հայրենասիրական ու հայրենատիրական դաստիարակություն՝ ազգային արժեքային
            համակարգի արդիականացման հիմքով,
          </li>
          <li>
            կոլոգիական դաստիարակություն՝ բնապահպանական արժեքային համակարգի
            հիմքով։
          </li>
        </ul>
        <p class="text-black my-4 font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <strong>
            Աշխարհագրության ուսուցման գործընթացի առանցքում պետք է դնել
            սիներգիզմի գաղափարախոսությունը:
          </strong>
        </p>
        <p className="my-4 text-[#493ED3] font-noto-sans-armenian text-[18px] font-semibold leading-normal">
          «Ազգային Դպրոցում» աշխարհագրություն առարկայի նպատակն իրացնելու համար
          պետք է ճիշտ սահմանել առարկայի բովանդակությունը:
        </p>
        <p className="text-black indent-8 font-noto-sans-armenian text-[18px] font-medium leading-normal">
          Ազգային դպրոցի ընդհանուր ծրագրի «Աշխարհագրություն» և «Հայաստանի
          աշխարհագրություն» ուսումնական առարկաների բովանդակությունը,
          չափորոշիչները, օրինակելի ծրագրերը և էլեկտրոնային դասագրքրերը մշակվել
          են «Հանրակրթության մասին» ՀՀ օրենքի, «Հանրակրթության պետական
          չափորոշիչի» (ՀՀ կառավարության 04.02.2021թ. N 136-Ն որոշում),
          «Աշխարհագրություն» (7-8-րդ դասարաններ) և «Հայաստանի աշխարհագրություն»
          (9-րդ դասարան) առարկաների չափորոշիչների և ծրագրերի, ավագ դպրոցի
          «Աշխարհագրություն» առարկայի ընդհանուր և խորացված ուսուցման
          դասընթացների չափորոշիչների և ծրագրերի հիման վրա, որոնք արդիականացվել
          են՝ ելնելով «Ազգային կրթակարգի» քաղաքակրթական պահանջներից։
        </p>
        <p className="text-black indent-8 font-noto-sans-armenian text-[18px] font-medium leading-normal">
          «Ազգային Դպրոցում» աշխարհագրության ուսուցման բովանդակությունը ներառում
          է դպրոցական աշխարհագրության ողջ գիտելիքների բովանդակությունը՝ ներառյալ
          ուսումնական պլանները, թեմատիկ և օրական պլանների նպատակային
          ձևանմուշները, էլեկտրոնային դասագրքերը, ինչպես նաև աշխարհագրության
          տեսողական ուսուցման տարբեր միջոցներ՝ տեսադասեր, տեսասահիկներ, առցանց
          ուսուցման հարթակներ, հարցարան իր գնահատման համակարգով, գործնական
          աշխատանքներ, ուսուցման արդյունքները պարզելու համար թեստեր և այլն:
        </p>
        <p className="my-4 text-[#493ED3] font-noto-sans-armenian text-[18px] font-semibold leading-normal">
          «Ազգային Դպրոցում» աշխարհագրություն առարկայի չափորոշիչը ներառում է․
        </p>
        <ul className="ml-4 list-decimal pl-5 text-black font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <li>
            «Աշխարհագրություն» և «Հայաստանի աշխարհագրություն» ուսումնական
            առարկաների ուսուցման նպատակը՝ ըստ կրթական աստիճանների,
          </li>
          <li>
            «Աշխարհագրություն» և «Հայաստանի աշխարհագրություն» ուսումնական
            առարկաների ընդհանուր բնութագիրը,
          </li>
          <li>
            աշխարհագրության բովանդակության կառուցման հիմնական սկզբունքները,
          </li>
          <li>
            «Աշխարհագրություն» և «Հայաստանի աշխարհագրություն» ուսումնական
            առարկաների հիմնական գաղափարները և ակնկալվող վերջնարդյունքները՝ ըստ
            կրթական աստիճանների և դասարանների,
          </li>
          <li>սովորողների ուսումնառության արդյունքների գնահատումը,</li>
          <li>
            ուսումնական գործընթացի ուսումնամեթոդական և նյութատեխնիկական
            աջակցության նկարագրությունը։
          </li>
        </ul>
        <p className="my-4 text-[#493ED3] font-noto-sans-armenian text-[18px] font-semibold leading-normal">
          «Աշխարհագրություն» (7-8-րդ, 10-12-րդ դասարաններ) և «Հայաստանի
          աշխարհագրություն» (9-րդ դասարան) ուսումնական առարկաների օրինակելի
          ծրագրերը ներառում են.
        </p>
        <ul className="ml-4 list-decimal pl-5 text-black font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <li>ժամաքանակի բաշխում՝ ըստ դասարանների,</li>
          <li>
            թեմաներն ու դրանց բովանդակությունը, ինչպես նաև յուրաքանչյուր թեմայի
            նպատակն ու ակնկալվող վերջնարդյունքները,
          </li>
          <li>բովանդակությունը, գործնական աշխատանքները,</li>
          <li>ընդհանրական խաչվող հասկացությունները, միջառարկայական կապերը,</li>
          <li>ամբողջացված կապն ազգային կրթակարգի քաղաքակրթական հիմքի հետ:</li>
        </ul>
        <h3 class="text-[#493ED3] font-noto-sans-armenian text-[24px] font-semibold leading-normal my-4">
          ԲԱԺԻՆ 2. «ԱՇԽԱՐՀԱԳՐՈՒԹՅՈՒՆ» ԵՎ «ՀԱՅԱՍՏԱՆԻ ԱՇԽԱՐՀԱԳՐՈՒԹՅՈՒՆ»
          ՈՒՍՈՒՄՆԱԿԱՆ ԱՌԱՐԿԱՆԵՐԻ ՈՒՍՈՒՑՄԱՆ ՆՊԱՏԱԿԸ՝ ԸՍՏ ԿՐԹԱԿԱՆ ԱՍՏԻՃԱՆՆԵՐԻ
        </h3>
        <p className="text-black indent-8 font-noto-sans-armenian text-[18px] font-medium leading-normal">
          «Ազգային Դպրոցում» «Աշխարհագրություն» և «Հայաստանի աշխարհագրություն»
          ուսումնական առարկաների դասընթացների հիմնական նպատակը սովորողների
          համակարգված աշխարհաճանաչողության ձևավորումն ու զարգացումն է՝ հիմնված
          աշխարհագրական գիտական մտածողության վրա: Այն ուղղված է բնական և
          հասարակական աշխարհագրությունից ձեռքբերված գիտելիքների հիման վրա
          սովորողների գիտական աշխարհայացքի ձևավորմանը, կյանքում նրանց ստացած
          աշխարհագրական գիտելիքների և կարողությունների օգտագործման
          հմտությունների, դիրքորոշման և ազգային և համամարդկային արժեքների
          ձևավորմանը և զարգացմանը:
        </p>
        <p className="my-4 text-[#493ED3] font-noto-sans-armenian text-[18px] font-semibold leading-normal">
          «Ազգային Դպրոցի» տարրական օղակում աշխարհագրության ուսուցման նպատակներն
          են․
        </p>
        <ul className="ml-4 list-disc pl-5 text-black font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <li>
            մարդուն՝ որպես բնության և հասարակության անբաժանելի մասնիկ ընկալելու,
            մարդկանց միջև գոյություն ունեցող ռասայական, ազգային, կրոնական,
            մշակութային և աշխատանքային գործունեության տարբերությունները
            զանազանելու կարողությունների ձևավորումը,
          </li>
          <li>
            քարտեզից և շրջակա աշխարհի մասին հանրամատչելի այլ աղբյուրներից,
            բնական և հասարակական օբյեկտների ու երևույթների վերաբերյալ
            տեղեկույթից օգտվելու և այն առօրյայում կիրառելու հմտությունների
            զարգացումը:
          </li>
          <li>
            ազգային պատկանելիության, հայրենիքի գաղափարական ընկալման, ազգային
            արժենքերի նվազագույն գիտելիքների, արդարության մասին առաջին
            պատկերացումների ձևավորում և դրանց զարգացում:
          </li>
        </ul>
        <p className="my-4 text-[#493ED3] font-noto-sans-armenian text-[18px] font-semibold leading-normal"></p>
        <ul className="ml-4 list-decimal pl-5 text-black font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <li>
            Երկիր մոլորակի ոլորտներում և դրանց բաղադրիչներում ընթացող բնական
            երևույթների պատճառների, փոխառնչությունների, տարածքային տեղաբաշխման և
            հիմնական օրինաչափությունների ճանաչումը,
          </li>
          <li>
            աշխարհագրական թաղանթի ոլորտների հիմնական բաղադրիչների, դրանց
            փոխպայմանավորվածության, զարգացման և տարածքային օրինաչափությունների
            մասին համակարգված գիտելիքների ձեռքբերումը,
          </li>
          <li>
            մարդու, բնության, կենդանի օրգանիզմների և շրջակա միջավայրի
            փոխազդեցությունների իրական ընկալումը,
          </li>
          <li>
            աշխարհամասերի, տարածաշրջանների, երկրների բնական պայմանների, դրանց
            բնակչության, տնտեսության ճյուղային ու տարածքային
            առանձնահատկությունների և օրինաչափությունների վերաբերյալ համակարգված
            գիտելիքների ձեռքբերումը և զարգացումը,
          </li>
          <li>
            Հայաստանի բնության, բնակչության և տնտեսության աշխարհագրական
            առանձնահատկությունները բացատրելու և վերլուծելու հմտությունների
            զարգացումը որպես գլխավոր նպատակ սահմանելով՝ հայրենաճանաչությամբ
            սերմանել հայրենասիրություն,
          </li>
          <li>
            «Հայաստանի աշխարհագրության» դասընթացի շնորհիվ ազգային արժեքների
            ընկալումը՝ որպես Հայկական քաղաքակրթության արժեքային բաղադրիչներ, այս
            հիմքով քաղաքակրթական դաստիարակության ապահովում, քաղաքակրթական
            առաքելության փոխանցում,
          </li>
        </ul>
        <p className="my-4 text-[#493ED3] font-noto-sans-armenian text-[18px] font-semibold leading-normal">
          Միջնակարգ (ավագ) դպրոցում աշխարհագրության ուսուցման նպատակներն են.
        </p>
        <ul className="ml-4 list-decimal pl-5 text-black font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <li>
            երկրագնդի առանձին բաղադրիչների ֆիզիկաաշխարհագրական բնութագրիչներով
            համալիր վերլուծության հմտությունների ձևավորումը,
          </li>
          <li>
            քարտեզագրման նպատակներով նոր տեխնոլոգիաների, ԱՏՀ-ի և գլոբալ
            տեղորոշման համակարգերի կիրառման ոչ բարդ հմտությունների ձևավոր ու
            զարգացումը,
          </li>
          <li>
            աշխարհի բնակչության և համաշխարհային տնտեսության տարածքային
            կազմակերպման և ճյուղային կառուցվածքի ու օրինաչափությունների
            վերլուծության հմտությունների զարգացումը,
          </li>
          <li>
            մարդ-բնություն փոխհարաբերության էկոլոգիական տեսանկյուններից համալիր
            վերլուծության կարողության զարգացումը,
          </li>
          <li>
            մարդկության համամոլորակային հիմնախնդիրների և ինքնատիպ
            տարածաշրջանների համալիր աշխարհագրական բնութագրման և վերլուծության
            կարողության զարգացումը,
          </li>
          <li>
            ստացված ԳԿՀ-ի շնորհիվ բոլոր աշխարհագրական երևույթները, գործընթացներն
            ու օբյեկտները դիտարկել համամարդկային քաղաքակրթության ցիկլային
            շարժընթացի համատեքստում,
          </li>
          <li>
            կարևորել «Արդար հասարակարգի» ձևավորման հրամայականը, իր դրսևորման
            բոլոր՝ միջանձնային, ներհասարակական, ներպետական և միջհասարակական ու
            միջպետական մակարդակներում,
          </li>
        </ul>
        <p className="my-4 indent-8 text-[#493ED3] font-noto-sans-armenian text-[18px] font-semibold leading-normal">
          <strong>
            «Աշխարհագրության» և «Հայաստանի աշխարհագրության» դասընթացներն իրենց
            քաղաքակրթական բովանդակությամբ ուսումնադաստիրակաչական գործընթացի
            արդյունքում պետք է կրթեն և դաստիարակեն ապագայի «Արդար հասարակարգի»
            համար կենսագործող «Արարատյան մարդուն»:
          </strong>
        </p>
      </div>
    </div>
  ) : null;
};

export default ConceptsId;
